import { getIvrService } from "@ntconnect/framework/pbx";

export const fetchIvrMenus = (domain, page, pageSize, search) =>
  getIvrService().fetchIvrMenus(domain, page, pageSize, search);

export const fetchIvrMenu = (domain, id) =>
  getIvrService().fetchIvrMenu(domain, id);

export const createIvrMenu = (domain, params) =>
  getIvrService().createIvrMenu(domain, params);

export const updateIvrMenu = (domain, id, params) =>
  getIvrService().updateIvrMenu(domain, id, params);

export const deleteIvrMenu = (domain, id) =>
  getIvrService().deleteIvrMenu(domain, id);

export const fetchIvrOptions = (domain, menuId, page, pageSize) =>
  getIvrService().fetchIvrOptions(domain, menuId, page, pageSize);

export const fetchIvrOption = (domain, menuId, optionId) =>
  getIvrService().fetchIvrOption(domain, menuId, optionId);

export const createIvrOption = (domain, menuId, params) =>
  getIvrService().createIvrOption(domain, menuId, params);

export const updateIvrOption = (domain, menuId, optionId, params) =>
  getIvrService().updateIvrOption(domain, menuId, optionId, params);

export const deleteIvrOption = (domain, menuId, optionId) =>
  getIvrService().deleteIvrOption(domain, menuId, optionId);
